const CALLBACK_NAME = 'io-callback-name'

class IntersectionObserverProvider {
  _io
  _map
  constructor() {
    this._io = new IntersectionObserver(this.callback, this.options)
    this._map = {}
  }

  get callback() {
    return function (entries, observer) {
      entries.forEach((e) => {
        const callback = e.target[CALLBACK_NAME]
        callback && callback(e, observer)
      })
    }
  }

  get options() {
    return { threshold: [0, 1] }
  }

  unobserve(el) {
    this._io.unobserve(el)
  }

  observe(el, callback) {
    if (el === undefined || el == null)
      throw new Error('The element is invalid.')
    if (callback === undefined || callback == null)
      throw new Error('The callback is invalid.')
    el[CALLBACK_NAME] = callback
    this._io.observe(el)
  }
}

const instance = new IntersectionObserverProvider()

export default instance
